import { render, staticRenderFns } from "./PayMiddle.vue?vue&type=template&id=99673b96&scoped=true&"
import script from "./PayMiddle.vue?vue&type=script&lang=js&"
export * from "./PayMiddle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99673b96",
  null
  
)

export default component.exports